import PanelInlineContent from "../../lib/panel/panel-inline-content";
import { ToggleGroup, ToggleGroupItem } from "@babackapp/ui/components/toggle-group";
import { EyeOff } from "lucide-react";
import { useBlockPanelPropsContext } from "../../lib/panel/panel-container";
import { PackageContentBlock, PackageContentBlockProps } from "./types";
import { useTranslation } from "react-i18next";

export default function EmailPanelHidePrices() {
  const { t } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext<PackageContentBlockProps>();
  const value = blockProps.block.properties?.hidePrices ? "on" : "off";

  const handleUpdate = (enabled: boolean) => {
    blockProps.formAPI.updateField<PackageContentBlock>(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        hidePrices: enabled,
      },
    });
  };

  return (
    <PanelInlineContent
      title={t(
        "editorBlocksLibrary.blocks.package-content.panel.hidePrices.title",
        "Hide prices",
      )}
    >
      <ToggleGroup
        variant="default"
        type="single"
        className="bg-background border shadow"
        value={value}
        onValueChange={(value) => {
          if (value === "on" || value === "off") {
            handleUpdate(value === "on");
          }
        }}
      >
        <ToggleGroupItem value="on" aria-label="Hide prices">
          <EyeOff className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem value="off" aria-label="Show prices">
          <span className="text-xs font-medium">
            {t(
              "editorBlocksLibrary.blocks.package-content.panel.hidePrices.off",
              "Off",
            )}
          </span>
        </ToggleGroupItem>
      </ToggleGroup>
    </PanelInlineContent>
  );
}
